import { getContract, parseEventLogs, toHex } from 'viem';
import bridge from './abi/GrailBridge.json';
import { getTaprootPubToAddress } from './taproot';
import { retryUntilSuccess } from 'utils/retry-until';
import { getWalletClient } from '@wagmi/core';
import { wagmiConfig } from 'configs/wagmi';
import { CONTRACT_ADDRESSES } from 'configs/grail';
import { tracker } from 'utils/tracker';
import { getPublicClient } from 'utils/getPublicClient';
export const generatePegInID = () => {
    const randomBytes = crypto.getRandomValues(new Uint8Array(32));
    return toHex(randomBytes);
};
export async function generateUserPeginRequest(connector, pegInID, amount, evmAddress) {
    const chainId = tracker.store.getState().selectedChainId;
    if (!chainId) {
        throw new Error('Chain ID is not set');
    }
    const client = await getWalletClient(wagmiConfig, { connector });
    const contractAddress = CONTRACT_ADDRESSES[chainId];
    const contract = getContract({
        address: contractAddress,
        abi: bridge.abi,
        client,
    });
    return contract.write.generateUserPeginRequest([pegInID, amount, evmAddress], {
        chain: client.chain,
    });
}
export const getPegIn = (pegInId, chainId) => {
    const contractAddress = CONTRACT_ADDRESSES[chainId];
    if (!contractAddress) {
        throw new Error(`Unsupported chain ID: ${chainId}`);
    }
    const publicClient = getPublicClient();
    const contract = getContract({
        address: contractAddress,
        abi: bridge.abi,
        client: publicClient,
    });
    return contract.read.getPegin([pegInId]);
};
export async function waitAndDecodeReceipt(hash) {
    const publicClient = getPublicClient();
    const receipt = await publicClient.waitForTransactionReceipt({ hash });
    if (receipt.status === 'success') {
        const logs = parseEventLogs({
            logs: receipt.logs ?? [],
            abi: bridge.abi,
        });
        const peginGeneratedEvent = logs.find(item => item.eventName === 'PeginGenerated');
        const eventData = peginGeneratedEvent.args;
        const pegInId = eventData.pegInID;
        const pegInAddress = eventData.peginAddress;
        const amount = eventData.amount;
        const evmAddress = eventData.evmAddress;
        const taprootAddress = getTaprootPubToAddress(pegInAddress);
        return {
            receipt,
            status: receipt.status,
            pegInId,
            pegInAddress,
            amount,
            evmAddress,
            taprootAddress,
        };
    }
    else {
        return {
            receipt,
            status: receipt.status,
            pegInId: null,
            pegInAddress: null,
            amount: null,
            evmAddress: null,
            taprootAddress: null,
        };
    }
}
export async function waitAndDecodeDeposit(txId, signal) {
    return await retryUntilSuccess(async () => {
        const res = await fetch(`https://mempool.space/testnet/api/tx/${txId}`, {
            signal,
        });
        if (!res.ok) {
            throw new Error('Request failed');
        }
        const data = (await res.json());
        if (!data?.status?.confirmed) {
            throw new Error('Transaction not confirmed');
        }
        return data;
    }, { interval: 5000, signal });
}
// todo: add correct states
export async function waitForBridge(pegInId, chainId, signal) {
    return await retryUntilSuccess(async () => {
        const res = await getPegIn(pegInId, chainId);
        if (res.state === 0) {
            console.log('Pegin does not exist');
            return { ok: false, ...res };
        }
        if (res.state === 2) {
            return { ok: true, ...res };
        }
        throw new Error('Pegin is not completed yet');
    }, { interval: 15000, signal });
}
